import type { GraphKey } from '../models';

export const MOCK_GRAPH_KEYS: GraphKey[] = [
  {
    key: 'frequency-of-negotiations',
    label: 'Frequency of Negotiations',
    description: 'Static graph for negotiation frequency.',
    graph: null,
  },
  {
    key: 'topics-of-negotiations',
    label: 'Topics of Negotiations',
    description: 'Static graph for negotiation topics.',
    graph: null,
  },
  {
    key: 'successful-negotiation-of-topic-in-intrastate-conflict',
    label: 'Successful negotiation of topic in intrastate conflict',
    description: 'Static graph for successful topic negotiation in intrastate conflict.',
    graph: null,
  },
  {
    key: 'rounds-of-negotiations-ending-with-an-agreement-in-intrastate-conflict',
    label: 'Rounds of negotiations ending with an agreement in intrastate conflict',
    description:
      'Static graph for negotiation rounds ending with an agreement in intrastate conflict.',
    graph: null,
  },
  {
    key: 'rounds-of-negotiations-ending-with-a-peace-agreement-in-intrastate-conflict',
    label: 'Rounds of negotiations ending with a peace agreement in intrastate conflict',
    description:
      'Static graph for negotiation rounds ending with a peace agreement in intrastate conflict.',
    graph: null,
  },
  {
    key: 'mediator-type-in-mediated-round-of-negotiations',
    label: 'Mediator type in mediated round of negotiations',
    description: 'Static graph for mediator types in mediated rounds of negotiations.',
    graph: null,
  },
  {
    key: 'mediation-in-active-intrastate-conflict-dyads',
    label: 'Mediation in active intrastate conflict dyads',
    description: 'Static graph for mediation in active intrastate conflict dyads.',
    graph: null,
  },
  {
    key: 'mediated-and-bilateral-rounds-of-negotiations-in-active-intrastate-conflict-dyads',
    label: 'Mediated and bilateral rounds of negotiations in active intrastate conflict dyads',
    description:
      'Static graph for mediated and bilateral negotiation rounds in active intrastate conflict dyads.',
    graph: null,
  },
];
